import { BasicProps } from "@components/ComponentsInterface";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Permission } from "@store/generalTypes";
import { isEmpty } from "lodash";

const mapIntoPairs = (arr: Permission[]): Permission[][] => {
    return arr.reduce((acc: Permission[][], val, i) => {
        if (i % 2 === 0) {
            acc.push([val, arr[i + 1]]);
        }
        return acc;
    }, []);
};

export const PermissionDetail = ({ title, permissions }: PermissionListProps): JSX.Element => {
    if (isEmpty(permissions)) {
        return <></>;
    }

    const pairPermissions = mapIntoPairs(permissions);

    return (
        <div className="py-4">
            <h1 className="title is-6 has-text-ldark-gray">{title}</h1>
            {pairPermissions.map((x) => {
                const [left, right] = x;
                return (
                    <div className="columns" key={`${left.name}-${right?.name ?? "key"}`}>
                        <div className="column is-full-mobile is-half-tablet is-one-third-desktop has-text-ldark-gray">
                            <FontAwesomeIcon className="has-text-success" icon={faCheck} /> {left.name}
                        </div>
                        {right && (
                            <div className="column is-full-mobile is-half-tablet is-one-third-desktop has-text-ldark-gray">
                                <FontAwesomeIcon className="has-text-success" icon={faCheck} /> {right.name}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

interface PermissionListProps extends BasicProps {
    title: string;
    permissions: Permission[];
}
